import type { TranslationMessages } from "ra-core";

// Vietnamese translation of the react-admin core (ra-core v5) and ra-supabase
// messages. The published ra-language-vietnamese package targets react-admin
// v3 and misses many current keys, so the catalog is maintained here.
export const vietnameseRaMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Thêm bộ lọc",
      add: "Thêm",
      back: "Quay lại",
      bulk_actions:
        "Đã chọn %{smart_count} mục |||| Đã chọn %{smart_count} mục",
      cancel: "Hủy",
      clear_array_input: "Xóa danh sách",
      clear_input_value: "Xóa giá trị",
      clone: "Nhân bản",
      confirm: "Xác nhận",
      create: "Tạo mới",
      create_item: "Tạo %{item}",
      delete: "Xóa",
      edit: "Sửa",
      export: "Xuất",
      list: "Danh sách",
      refresh: "Làm mới",
      remove_filter: "Bỏ bộ lọc này",
      remove_all_filters: "Bỏ tất cả bộ lọc",
      remove: "Gỡ bỏ",
      reset: "Đặt lại",
      save: "Lưu",
      search: "Tìm kiếm",
      search_columns: "Tìm cột",
      select_all: "Chọn tất cả",
      select_all_button: "Chọn tất cả",
      select_row: "Chọn dòng này",
      show: "Xem",
      sort: "Sắp xếp",
      undo: "Hoàn tác",
      unselect: "Bỏ chọn",
      expand: "Mở rộng",
      close: "Đóng",
      open_menu: "Mở menu",
      close_menu: "Đóng menu",
      update: "Cập nhật",
      move_up: "Lên trên",
      move_down: "Xuống dưới",
      open: "Mở",
      toggle_theme: "Đổi giao diện sáng/tối",
      select_columns: "Cột",
      update_application: "Tải lại ứng dụng",
    },
    boolean: {
      true: "Có",
      false: "Không",
      null: " ",
    },
    page: {
      create: "Tạo %{name}",
      dashboard: "Tổng quan",
      edit: "%{name} %{recordRepresentation}",
      error: "Đã có lỗi xảy ra",
      list: "%{name}",
      loading: "Đang tải",
      not_found: "Không tìm thấy",
      show: "%{name} %{recordRepresentation}",
      empty: "Chưa có %{name}.",
      invite: "Bạn có muốn thêm mới?",
      access_denied: "Không có quyền truy cập",
      authentication_error: "Lỗi xác thực",
    },
    input: {
      file: {
        upload_several: "Kéo thả các tệp vào đây, hoặc bấm để chọn.",
        upload_single: "Kéo thả tệp vào đây, hoặc bấm để chọn.",
      },
      image: {
        upload_several: "Kéo thả các ảnh vào đây, hoặc bấm để chọn.",
        upload_single: "Kéo thả ảnh vào đây, hoặc bấm để chọn.",
      },
      references: {
        all_missing: "Không tìm thấy dữ liệu liên kết.",
        many_missing: "Có ít nhất một dữ liệu liên kết không còn tồn tại.",
        single_missing: "Dữ liệu liên kết không còn tồn tại.",
      },
      password: {
        toggle_visible: "Ẩn mật khẩu",
        toggle_hidden: "Hiện mật khẩu",
      },
    },
    message: {
      about: "Giới thiệu",
      access_denied: "Bạn không có quyền truy cập trang này",
      are_you_sure: "Bạn có chắc chắn?",
      authentication_error:
        "Máy chủ xác thực báo lỗi, không kiểm tra được thông tin đăng nhập.",
      auth_error: "Có lỗi khi kiểm tra phiên đăng nhập.",
      bulk_delete_content:
        "Bạn có chắc muốn xóa %{name} này? |||| Bạn có chắc muốn xóa %{smart_count} mục này?",
      bulk_delete_title: "Xóa %{name} |||| Xóa %{smart_count} %{name}",
      bulk_update_content:
        "Bạn có chắc muốn cập nhật %{name} %{recordRepresentation}? |||| Bạn có chắc muốn cập nhật %{smart_count} mục này?",
      bulk_update_title:
        "Cập nhật %{name} %{recordRepresentation} |||| Cập nhật %{smart_count} %{name}",
      clear_array_input: "Bạn có chắc muốn xóa toàn bộ danh sách?",
      delete_content: "Bạn có chắc muốn xóa %{name} này?",
      delete_title: "Xóa %{name} %{recordRepresentation}",
      details: "Chi tiết",
      error: "Có lỗi phía trình duyệt, chưa thực hiện được yêu cầu.",
      invalid_form: "Biểu mẫu chưa hợp lệ. Vui lòng kiểm tra các lỗi",
      loading: "Vui lòng chờ",
      no: "Không",
      not_found: "Đường dẫn không đúng hoặc không còn tồn tại.",
      select_all_limit_reached:
        "Có quá nhiều mục để chọn hết. Chỉ %{max} mục đầu tiên được chọn.",
      unsaved_changes:
        "Một số thay đổi chưa được lưu. Bạn có chắc muốn bỏ qua?",
      yes: "Có",
      placeholder_data_warning: "Lỗi mạng: không làm mới được dữ liệu.",
    },
    navigation: {
      clear_filters: "Xóa bộ lọc",
      no_filtered_results: "Không có %{name} nào khớp bộ lọc hiện tại.",
      no_results: "Không có %{name} nào",
      no_more_results: "Trang %{page} vượt quá giới hạn. Hãy thử trang trước.",
      page_out_of_boundaries: "Trang %{page} vượt quá giới hạn",
      page_out_from_end: "Đã ở trang cuối",
      page_out_from_begin: "Đã ở trang đầu",
      page_range_info: "%{offsetBegin}-%{offsetEnd} / %{total}",
      partial_page_range_info: "%{offsetBegin}-%{offsetEnd} / hơn %{offsetEnd}",
      current_page: "Trang %{page}",
      page: "Tới trang %{page}",
      first: "Tới trang đầu",
      last: "Tới trang cuối",
      next: "Trang sau",
      previous: "Trang trước",
      page_rows_per_page: "Số dòng mỗi trang:",
      skip_nav: "Bỏ qua tới nội dung",
    },
    sort: {
      sort_by: "Sắp xếp theo %{field_lower_first} %{order}",
      ASC: "tăng dần",
      DESC: "giảm dần",
    },
    auth: {
      auth_check_error: "Vui lòng đăng nhập để tiếp tục",
      user_menu: "Hồ sơ",
      username: "Tên đăng nhập",
      password: "Mật khẩu",
      email: "Email",
      sign_in: "Đăng nhập",
      sign_in_error: "Đăng nhập không thành công, vui lòng thử lại",
      logout: "Đăng xuất",
    },
    notification: {
      updated: "Đã cập nhật |||| Đã cập nhật %{smart_count} mục",
      created: "Đã tạo",
      deleted: "Đã xóa |||| Đã xóa %{smart_count} mục",
      bad_item: "Dữ liệu không đúng",
      item_doesnt_exist: "Dữ liệu không tồn tại",
      http_error: "Lỗi kết nối máy chủ",
      data_provider_error: "Lỗi dữ liệu. Xem console để biết chi tiết.",
      i18n_error: "Không tải được bản dịch cho ngôn ngữ này",
      canceled: "Đã hủy thao tác",
      logged_out: "Phiên làm việc đã hết, vui lòng đăng nhập lại.",
      not_authorized: "Bạn không có quyền truy cập dữ liệu này.",
      application_update_available: "Đã có phiên bản mới.",
      offline: "Mất kết nối mạng. Không tải được dữ liệu.",
    },
    validation: {
      required: "Bắt buộc",
      minLength: "Tối thiểu %{min} ký tự",
      maxLength: "Tối đa %{max} ký tự",
      minValue: "Tối thiểu là %{min}",
      maxValue: "Tối đa là %{max}",
      number: "Phải là số",
      email: "Email không hợp lệ",
      oneOf: "Phải là một trong: %{options}",
      regex: "Phải đúng định dạng (regexp): %{pattern}",
      unique: "Không được trùng",
    },
    saved_queries: {
      label: "Bộ lọc đã lưu",
      query_name: "Tên bộ lọc",
      new_label: "Lưu bộ lọc hiện tại...",
      new_dialog_title: "Lưu bộ lọc hiện tại với tên",
      remove_label: "Xóa bộ lọc đã lưu",
      remove_label_with_name: 'Xóa bộ lọc "%{name}"',
      remove_dialog_title: "Xóa bộ lọc đã lưu?",
      remove_message: "Bạn có chắc muốn xóa bộ lọc này khỏi danh sách đã lưu?",
      help: "Lọc danh sách rồi lưu lại để dùng sau",
    },
    guesser: {
      empty: {
        title: "Không có dữ liệu để hiển thị",
        message: "Vui lòng kiểm tra nguồn dữ liệu",
      },
    },
    configurable: {
      customize: "Tùy chỉnh",
      configureMode: "Tùy chỉnh trang này",
      inspector: {
        title: "Trình kiểm tra",
        content: "Rê chuột lên các thành phần giao diện để tùy chỉnh",
        reset: "Đặt lại cài đặt",
        hideAll: "Ẩn tất cả",
        showAll: "Hiện tất cả",
      },
      Datagrid: {
        title: "Bảng dữ liệu",
        unlabeled: "Cột chưa đặt tên #%{column}",
      },
      SimpleForm: {
        title: "Biểu mẫu",
        unlabeled: "Ô nhập chưa đặt tên #%{input}",
      },
      SimpleList: {
        title: "Danh sách",
        primaryText: "Dòng chính",
        secondaryText: "Dòng phụ",
        tertiaryText: "Dòng thứ ba",
      },
    },
  },
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Nhập lại mật khẩu",
      sign_in_with: "Đăng nhập bằng %{provider}",
      forgot_password: "Quên mật khẩu?",
      reset_password: "Đặt lại mật khẩu",
      password_reset: "Hãy kiểm tra email để nhận thư đặt lại mật khẩu.",
      missing_tokens: "Thiếu mã truy cập",
      back_to_login: "Quay lại đăng nhập",
    },
    reset_password: {
      forgot_password: "Quên mật khẩu?",
      forgot_password_details: "Nhập email để nhận hướng dẫn.",
    },
    set_password: {
      new_password: "Đặt mật khẩu",
    },
    validation: {
      password_mismatch: "Mật khẩu không khớp",
    },
    oauth: {
      authorize: "Cấp quyền ứng dụng",
      authorize_details: "Ứng dụng này muốn truy cập tài khoản của bạn.",
      access_scope:
        "Ứng dụng sẽ đọc và sửa được dữ liệu, với cùng quyền như tài khoản của bạn.",
      approved: "Đã cấp quyền",
      close_tab: "Bạn có thể đóng tab này.",
      no_request: "Không tìm thấy yêu cầu cấp quyền",
    },
  },
};
